/** @file Provides a simple, native toast library for Modal. */

import { toast } from "svelte-sonner";
import { v4 as uuidv4 } from "uuid";

import { normalizeError } from "$lib/core/error";
import ToastComponent from "$lib/design-systems/product/primitives/feedback/Toast.svelte";

export type Toast = {
  message: string;
  link?: { name: string; href: string };
} & (
  | { kind: "info" | "success" | "error" }
  | { kind: "activity"; user: { name: string; avatarUrl?: string } }
);

export function makeToast(t: Toast, duration: number = 3000) {
  const id = uuidv4();
  toast(ToastComponent, {
    id,
    duration,
    unstyled: true,
    componentProps: { id, ...t },
  });
}

export async function makeErrorToast(error: Error) {
  makeToast(
    {
      kind: "error",
      message: await normalizeError(error),
    },
    5000,
  );
}
